<div class="select-component">
    <label *ngIf="title" class="title">{{title}}</label>
    <div class="select" [class.fit-content]="widthFitContent">
        <select [name]="name" [disabled]="disabled" (click)="open = !open" (ngChange)="open = false" (blur)="open = false" (change)="emit($event)">
            <option value="" disabled [selected]="selectedValue == '' || selectedValue == null">{{placeholder}}</option>
            <ng-container *ngIf="options && options.length">
                <ng-container *ngFor="let opt of options | orderBy: 'label'">
                    <option [value]="opt.value" [selected]="opt.selected || selectedValue == opt.value" [disabled]="opt.disabled">
                        {{opt.label}}
                    </option>
                </ng-container>
            </ng-container>
        </select>
        <i class="fas" [ngClass]="open ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </div>
</div>